import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchRoles, createRol, updateRol, deleteRol } from "../api/adminService";

export const useRoles = () => {
  const queryClient = useQueryClient();

  // ✅ Consulta optimizada para obtener los roles
  const {
    data: roles = [], // Previene `undefined` al hacer `.map()`
    error,
    isLoading,
  } = useQuery({
    queryKey: ["roles"],
    queryFn: fetchRoles,
    staleTime: 1000 * 60 * 5, // Cachea los datos por 5 minutos
    refetchOnWindowFocus: false, // Evita re-fetch cuando se cambia de ventana
    refetchOnMount: false, // No re-fetch al montar el componente si ya está en caché
    refetchOnReconnect: false, // Evita re-fetch al reconectar a la red
  });

  // ✅ Roles reutilizable para invalidar la caché después de cada mutación
  const invalidateRolesCache = () => {
    queryClient.invalidateQueries({ queryKey: ["roles"] });
  };

  // ✅ Mutación para crear un rol
  const createMutation = useMutation({
    mutationFn: createRol,
    onSuccess: invalidateRolesCache,
  });

  // ✅ Mutación para actualizar un rol
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateRol(id, data),
    onSuccess: invalidateRolesCache,
  });

  // ✅ Mutación para eliminar un rol
  const deleteMutation = useMutation({
    mutationFn: deleteRol,
    onSuccess: invalidateRolesCache,
  });

  return {
    roles, // Siempre un array seguro
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
